/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersDto as DigiworkMaitreDDtoUsersDto } from '../../models/Digiwork/MaitreD/DTO/users-dto';

export interface ListManagerEmployeesForVenue$Params {
  VenueId?: string;
  CompanyId?: string;
}

export function listManagerEmployeesForVenue(http: HttpClient, rootUrl: string, params?: ListManagerEmployeesForVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDDtoUsersDto>> {
  const rb = new RequestBuilder(rootUrl, listManagerEmployeesForVenue.PATH, 'get');
  if (params) {
    rb.query('VenueId', params.VenueId, {});
    rb.query('CompanyId', params.CompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDDtoUsersDto>;
    })
  );
}

listManagerEmployeesForVenue.PATH = '/api/gmn/Employee/listmanageremployeesforvenue';
